import { CORVA_API_URLS } from '~/clients/constants';

// CORVA_COMPANY_ID is a "magic" number, always 1, with few critical legacy exceptions
const detectedCorvaCompanyId = (() => {
  const idFromEnv = parseInt(process.env.REACT_APP_CORVA_COMPANY_ID, 10);
  if (idFromEnv) return idFromEnv;

  // detect legacy envs
  const apiUrl = String(CORVA_API_URLS.API);
  if (apiUrl.startsWith('https://api.corva.ai')) return 3; // corva-us-production
  if (apiUrl.startsWith('https://api.staging.corva.ai/')) return 2; // corva-us-staging

  return 1; // everywhere else
})();

export const CORVA_COMPANY_ID = detectedCorvaCompanyId;
export const CORVA_COMPANY_PROVIDER = 'corva';
export const CORVA_COMPANY_NAME = 'Corva';
